<template>
  <div class="preview-container">
    <b-overlay
      id="overlay-background"
      :show="loading"
      variant="light"
      opacity="1"
    >
      <div>
        <h3 class="mb-2">
          {{ $t('partnerView.titlePreviewLandingPage') }}
        </h3>
        <div class="d-flex flex-wrap flex-md-nowrap">
          <div class="contacts-container">
            <h4 class="title-info">
              {{ $t('partnerContactPage.textContactInformation') }}
            </h4>

            <div>
              <p class="content-title-info">
                {{ $t('common.labelBusinessName') }}
              </p>
              <p
                class="text-content-info"
              >
                {{ businessName }}
              </p>
            </div>

            <div class="line-center" />

            <div class="ref-code">
              <p class="content-title-info">
                {{ $t('partnerContactPage.textRefCode') }}
              </p>
              <a
                :href="refCode"
                target="_blank"
                rel="noopener noreferrer"
                class="text-content-info underline"
              >
                {{ refCode }}
              </a>
            </div>

            <!--            <div class="line-center" />-->

            <!--            <div>-->
            <!--              <p class="content-title-info">-->
            <!--                Phone number-->
            <!--              </p>-->
            <!--              <p-->
            <!--                class="text-content-info"-->
            <!--              >-->
            <!--                {{ phoneNumber }}-->
            <!--              </p>-->
            <!--            </div>-->

            <div class="line-center" />

            <div style="width: 50%">
              <p class="content-title-info">
                {{ $t('stepGuideControl.stepVerifyInfo.labelCountry') }}
              </p>
              <p
                class="text-content-info"
              >
                {{ country }}
              </p>
            </div>

            <div class="line-center" />

            <div style="width: 50%">
              <p class="content-title-info">
                {{ $t('partnerContactPage.textLandingPage') }}
              </p>
              <div>
                <a
                  v-if="landingPage"
                  :href="landingPage"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="underline text-content-info"
                >{{ landingPage }}</a>
                <p
                  v-else
                  class="text-content-info"
                >
                  N/A
                </p>
              </div>
            </div>

            <div class="line-center" />

            <div>
              <div>
                <p class="content-title-info">
                  {{ $t('partnerContactPage.textCommunityGroup') }}
                </p>
                <p
                  class="text-content-info"
                >
                  {{ communityGroup }}
                </p>
              </div>
            </div>
          </div>

          <div
            v-if="formEmbedURL && hasFormWhiteList"
            class="landing-page-container"
          >
            <div class="form-landing-page">
              <!-- <embed
                type="text/html"
                :src="formEmbedURL"
                class="embed-url"
              > -->
              <iframe
                :src="formEmbedURL"
                title="test"
                class="embed-url"
                :style="heightInput"
              />
              <div
                ref="urlBox"
                class="url-partner"
              >
                <a
                  :href="formEmbedURL"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="detail-url underline text-blue"
                >{{ formEmbedURL }}</a>
              </div>
            </div>
          </div>
          <div
            v-else
            class="no-ember"
          >
            <div class="__content">
              <feather-icon
                icon="InboxIcon"
                size="48"
              />
              <p>{{ $t('partnerContactPage.textNoEmbed') }}</p>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { BOverlay } from 'bootstrap-vue'
import { createNamespacedHelpers } from 'vuex'
import partnerMixin from '@/mixins/partnerMixin'

const { mapGetters } = createNamespacedHelpers('auth')

export default {
  components: {
    BOverlay,
  },

  mixins: [partnerMixin],

  data() {
    return {
      heightInput: { height: '100%' },
    }
  },

  computed: {
    ...mapGetters(['user', 'loading']),

    landingPage() {
      return this.user?.data?.partnership?.landingPage
    },

    businessName() {
      return this.user?.data?.fullName
    },

    refCode() {
      return this.user?.data?.referralTracking?.code
        ? `${this.isEcomdyPlatform ? process.env.VUE_APP_LOGIN_URL : process.env.VUE_APP_SITE_URL}/register?refcode=${this.user?.data?.referralTracking?.code}`
        : 'N/A'
    },

    // phoneNumber() {
    //   const { contactInfo } = this.user?.data
    //   if (contactInfo?.phone) {
    //     const phoneElm = contactInfo.phone.split('|')
    //     if (phoneElm.length === 3) {
    //       const phone = contactInfo.phone.split('|')
    //       return `+${phone[1]} ${phone[2]}`
    //     }
    //   }
    //   return 'N/A'
    // },

    country() {
      return this.user?.data?.country
    },

    communityGroup() {
      return this.user?.data?.partnership?.communityGroup || 'N/A'
    },

    // facebook() {
    //   return this.user?.data?.contactInfo?.facebook || 'N/A'
    // },
    //
    // telegram() {
    //   return this.user?.data?.contactInfo?.telegram || 'N/A'
    // },
    //
    // whatsApp() {
    //   return this.user?.data?.contactInfo?.whatsApp || 'N/A'
    // },

    formEmbedURL() {
      return this.user?.data?.partnership?.formEmbedURL
    },
  },

  watch: {
    user: {
      handler(user) {
        if (!user?.loading) {
          if (!this.hasFormWhiteList) {
            this.$router.push('/partner-management')
          }
          this.matchHeight()
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    matchHeight() {
      this.$nextTick(() => {
        this.heightInput.height = `calc(100% - ${(this.$refs.urlBox?.clientHeight + 23) || 0}px)`
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.preview-container {
  padding: 32px;
  border-radius: var(--border-radius-base);
  background: #fff;
  width: 100%;

  @media(max-width: 767px) {
    padding: 16px;
  }
}

.title-info {
  margin-bottom: 24px;
  font-size: 20px;
}

.contacts-container {
  width: 25%;
  margin-right: 24px;

  @media(max-width: 767px) {
    width: 100%;
  }
}

.landing-page-container {
  width: 75%;

  .form-landing-page {
    height: 100%;
    padding: 16px;
    border-radius: 16px;
    background: #F8F8F9;
  }

  @media(max-width: 767px) {
    width: 100%;
    height: 100vh;
    margin-top: 16px;

    .form-landing-page {
      padding: 0;
      background: #fff;

      .embed-url {
        border: 1px solid #e6e6e6;
      }
    }
  }
}

.embed-url {
  border-radius: 16px;
  width: 100%;
  height: calc(100vh - 110px);
  border: none;
}

.line-center {
  margin: 32px 0;
  height: 1px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.10);
}

.url-partner {
  margin-top: 16px;
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  border: 1px solid #e6e6e6;
  overflow-wrap: break-word;

  .detail-url {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }
}

.no-ember {
  width: 75%;
  display: flex;
  align-items: center;
  background: #f5f5f7;
  border-radius: var(--border-radius-base);

  .__content {
    width: max-content;
    margin: 0 auto;
    line-height: 1.25rem;
    font-weight: 600;
    text-align: center;
  }
}

.content-title-info {
  color: rgba(0, 0, 0, 0.70);
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 8px;
}

.text-content-info {
  color: #000;
  font-size: 16px;
  line-height: 24px; /* 150% */
  overflow-wrap: break-word;
}
</style>
